import { Box, Paper, Table, TableContainer } from "@mui/material";
import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useContext,
} from "react";
import RightContainer from "./Components/RightContainer";
import MetricesTableHeader from "./Components/MetricesTableHeader";
import MatricesTableBody from "./Components/MetricesTableBody";
import useApi from "../../service/api.service";
import { customDateConvert } from "../../components/Common/Utils/Utils";
import toast, { Toaster } from "react-hot-toast";
import html2canvas from "html2canvas";
import Header from "../../components/Common/Header";
import Navbar from "../../components/Common/Navbar";
import { useAuthContext } from "../../context/AuthProvider";
import { NotificationContext } from "../../context/NotificationContext";

function Metrices() {
  const tableData = {
    columns: [
      "",
      "Part Based Factors",
      "UCL",
      "LCL",
      //  "Agv. σ %"
    ],
  };
  const tableData1 = {
    columns: [
      "",
      "Per Minute Factors",
      "UCL",
      "LCL",
      //  "Agv. σ %"
    ],
  };
  const {
    selectedItemIds,
    setSelectedItemIds,
    selectedItemIds1,
    setSelectedItemIds1,
  } = useContext(NotificationContext);
  const { QCFull } = useAuthContext();
  const API = useApi();
  const [filteredRows, setFilteredRows] = useState([]);
  const [downloadAllow, setDownloadAllow] = useState(false);
  const [loading, setLoading] = useState(false);
  const oneDay = 24 * 60 * 60 * 1000;
  const oneWeek = 7 * oneDay;
  const defaultStartDate = new Date(Date.now() - oneWeek);
  const defaultEndDate = new Date(Date.now() - oneDay);
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
      enabled: false,
      status: false,
    },
  ]);
  const [finalDate, setFinalDate] = useState({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });

  const getFactorsData = async () => {
    const requestBodyParams = {
      startTime: finalDate.startDate
        ? customDateConvert(
            new Date(finalDate.startDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      endTime: finalDate.endDate
        ? customDateConvert(
            new Date(finalDate.endDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
    };
    try {
      setLoading(true);
      const response = await API.getFactorsData(requestBodyParams);
      setFilteredRows(
        response.data?.filter(
          (item) =>
            item.factorName !== "DRYINGTUNNEL_HOUR" &&
            item.factorName !== "DRYINGTUNNEL_MONTH" &&
            item.factorId !== 1000 &&
            item.factorId !== 1001 &&
            item.factorId !== 1002 &&
            item.factorId !== 1003 &&
            item.factorId !== 1004 &&
            item.factorId !== 1005
        )
      );
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    getFactorsData();
  }, [finalDate]);

  const startDate = finalDate.startDate
    ? new Date(finalDate.startDate)
    : defaultStartDate;
  const endDate = finalDate.endDate
    ? new Date(finalDate.endDate)
    : defaultEndDate;

  const captureRef = useRef(null);
  const takeScreenshot = () => {
    if (captureRef.current) {
      html2canvas(captureRef.current).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = `Control Chart Factor From ${customDateConvert(
          startDate,
          "MM-DD-YYYY"
        )} To ${customDateConvert(endDate, "MM-DD-YYYY")}.png`;
        link.click();
      });
      toast.success("Data downloaded successfully");
    }
  };

  const [filteredRows1, setFilteredRows1] = useState([]);

  const [loading1, setLoading1] = useState(false);
  const [dateRange1, setDateRange1] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
      enabled: false,
      status: false,
    },
  ]);
  const [finalDate1, setFinalDate1] = useState({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });

  const getFactorsData1 = async () => {
    const requestBodyParams1 = {
      startTime: finalDate1.startDate
        ? customDateConvert(
            new Date(finalDate1.startDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
      endTime: finalDate1.endDate
        ? customDateConvert(
            new Date(finalDate1.endDate).toLocaleDateString("en-US"),
            "YYYY-MM-DD"
          )
        : null,
    };
    try {
      setLoading1(true);
      const response1 = await API.getFactorsData(requestBodyParams1);
      setFilteredRows1(
        response1.data?.filter(
          (item) =>
            item.factorId === 1000 ||
            item.factorId === 1001 ||
            item.factorId === 1002 ||
            item.factorId === 1003 ||
            item.factorId === 1004 ||
            item.factorId === 1005
        )
      );
      setLoading1(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading1(false);
    }
  };
  useEffect(() => {
    getFactorsData1();
  }, [finalDate1]);

  const startDate1 = finalDate1.startDate
    ? new Date(finalDate1.startDate)
    : defaultStartDate;
  const endDate1 = finalDate1.endDate
    ? new Date(finalDate1.endDate)
    : defaultEndDate;

  const captureRef1 = useRef(null);
  const takeScreenshot1 = () => {
    if (captureRef1.current) {
      html2canvas(captureRef1.current).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = `Control Chart Factor From ${customDateConvert(
          startDate1,
          "MM-DD-YYYY"
        )} To ${customDateConvert(endDate1, "MM-DD-YYYY")}.png`;
        link.click();
      });
      toast.success("Data downloaded successfully");
    }
  };

  return (
    <>
      {!QCFull && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 1000,
          }}
        >
          <Header />
          <Navbar />
        </div>
      )}
      <Box
        ref={captureRef}
        sx={{
          display: "flex",
          width: QCFull ? "100%" : "98%",
          mx: "auto",
          gap: "1%",
          pt: QCFull ? 0 : 3,
          boxSizing: "border-box",
          height: QCFull ? "100vh" : `calc(100vh - 110px)`,
          overflow: "auto",
          mt: QCFull ? "0px" : "98px",
        }}
      >
        <Paper
          sx={{
            display: "flex",
            width: "23%",
            borderRadius: "20px",
            flexDirection: "column",
            height: "100%",
            boxShadow: "none",
          }}
        >
          <TableContainer
            sx={{
              width: "100%",
              maxHeight: QCFull ? "100vh" : "89.5vh",
              overflow: "auto",
              borderBottom: "1px solid #E4E4E4",
              borderRadius: "20px",
            }}
          >
            <Table aria-label="simple table" stickyHeader>
              <MetricesTableHeader tableData={tableData} />
              <MatricesTableBody
                data={filteredRows}
                loading={loading}
                selectedItemIds={selectedItemIds}
                setSelectedItemIds={setSelectedItemIds}
              />
            </Table>
          </TableContainer>
        </Paper>
        <Paper
          sx={{
            width: "77%",
            //   padding: "10px",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            boxSizing: "border-box",
            fontWeight: 500,
            color: "#404040",
            boxShadow: "none",
            border: "1px solid #E4E4E4",
            overflowY: "auto",
          }}
        >
          <RightContainer
            selectedItemIds={selectedItemIds}
            setDownloadAllow={setDownloadAllow}
            dateRange={dateRange}
            setDateRange={setDateRange}
            finalDate={finalDate}
            setFinalDate={setFinalDate}
            takeScreenshot={takeScreenshot}
            type="Type 1"
          />
        </Paper>
      </Box>
      <Box
        ref={captureRef1}
        sx={{
          display: "flex",
          width: QCFull ? "100%" : "98%",
          mx: "auto",
          gap: "1%",
          pt: QCFull ? 0 : 3,
          boxSizing: "border-box",
          height: QCFull ? "100vh" : `calc(100vh - 110px)`,
          overflow: "auto",
          marginTop: QCFull ? "20px" : "0px",
        }}
      >
        <Paper
          sx={{
            display: "flex",
            width: "23%",
            borderRadius: "25px",
            flexDirection: "column",
            height: "100%",
            boxShadow: "none",
          }}
        >
          <TableContainer
            sx={{
              width: "100%",
              maxHeight: QCFull ? "100vh" : "89.5vh",
              overflow: "auto",
            }}
          >
            <Table aria-label="simple table" stickyHeader>
              <MetricesTableHeader tableData={tableData1} />
              <MatricesTableBody
                data={filteredRows1}
                loading={loading1}
                selectedItemIds={selectedItemIds1}
                setSelectedItemIds={setSelectedItemIds1}
              />
            </Table>
          </TableContainer>
        </Paper>
        <Paper
          sx={{
            width: "77%",
            //   padding: "10px",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            boxSizing: "border-box",
            fontWeight: 500,
            color: "#404040",
            boxShadow: "none",
            border: "1px solid #E4E4E4",
            overflowY: "auto",
          }}
        >
          <RightContainer
            selectedItemIds={selectedItemIds1}
            setDownloadAllow={setDownloadAllow}
            dateRange={dateRange1}
            setDateRange={setDateRange1}
            finalDate={finalDate1}
            setFinalDate={setFinalDate1}
            takeScreenshot={takeScreenshot1}
            type="Type 2"
          />
        </Paper>
      </Box>
    </>
  );
}

export default Metrices;
